export default "__VITE_ASSET__D1xz8SWa__"